export type FolderPathBody = {
  filename: string,
  folderPath: string,
  guid: string,
}

export enum SaveLocationTypes {
  Default = 'default',
  OtherLocation = 'other'
}
